import {
  IFilterSet,
  isDateRangeFilter,
  isLimitedDateFilter,
  isMultiSelectFilter,
  isSingleSelectFilter,
  isTernaryFilter,
  isValidDateRange,
  isValidLimitedDate,
  isValidMultiSelect,
  isValidSingleSelect,
  isValidTernary,
  isValidValueRange,
  isValueRangeFilter,
} from '../typings'

export function serializeFilters<U, T extends IFilterSet<U>>({
  orderBy,
  filters,
}: T): string {
  const f = Object.keys(filters).reduce<Record<string, { value: unknown }>>(
    (prev, curr) => {
      const filter = filters[curr]

      if (isDateRangeFilter(filter) && !isValidDateRange(filter.value))
        return prev
      if (isSingleSelectFilter(filter) && !isValidSingleSelect(filter.value))
        return prev
      if (isMultiSelectFilter(filter) && !isValidMultiSelect(filter.value))
        return prev
      if (isValueRangeFilter(filter) && !isValidValueRange(filter.value))
        return prev
      if (isTernaryFilter(filter) && !isValidTernary(filter.value)) return prev
      if (isLimitedDateFilter(filter) && !isValidLimitedDate(filter.value))
        return prev

      return { ...prev, [curr]: { value: filters[curr].value } }
    },
    {},
  )
  const json = JSON.stringify({ orderBy, filters: f })
  return json
}
